import { call, put, takeLatest } from 'redux-saga/effects';

import { getSabrePnrPrintoutRequest, getSabrePnrPrintoutResponse } from '../../slices/trip';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* getSabrePnrPrintoutWorker({ payload }) {
  try {
    const config = {
      method: 'post',
      url: 'trips/getPnrPrintout',
      data: JSON.stringify(Object.values(payload)),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const response = yield call(axios, config);
    if (response.data) {
      yield put(getSabrePnrPrintoutResponse({ data: response.data }));
    } else throw new Error();
  } catch (error) {
    console.error(error);
    yield put(getSabrePnrPrintoutResponse({ data: null }));
  }
}

function* runSabreCommandWatcher() {
  yield takeLatest(getSabrePnrPrintoutRequest.toString(), getSabrePnrPrintoutWorker);
}

export default runSabreCommandWatcher;
